module.exports = __webpack_public_path__ + "static/media/varun@3x.eef76eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/varun@3x.png
// module id = 221
// module chunks = 1